import {COLUMN_CODE, TableManger as TableManager, TableManger, TABLES} from "../managers/TableManger";
import Table from "./table";
import TableDataParser from "../Helper/TableDataParser";

class ContactService {

    static addColumn(data, onSuccess, onError) {
        let tableId = TableManager.getTableId(TABLES.CANDIDATE)
        let columnData = TableDataParser.getColumnToAdd(data)
        Table.addColumn(columnData, tableId).then((response) => {
            onSuccess({data: response, columnData: columnData})
        }, error => {
            onError(error)
        });
    }

    static setTableColumns(onSuccess, onError) {
        Table.getTable(TableManger.getTableId(TABLES.CANDIDATE)).then(data => {
            TableManger.setTableColumns(data, TABLES.CANDIDATE);
            onSuccess()
        }, error => {
            onError(error)
        })
    }

    static updateColumn(columnData, onSuccess, onError) {
        let tableId = TableManager.getTableId(TABLES.CANDIDATE)
        Table.updateColumn(columnData, tableId).then((response) => {
            onSuccess({data: response})
        }, error => {
            onError(error)
        });
    }

    static getSegments() {
        let segment = TableManger.getColumn(TABLES.CANDIDATE, COLUMN_CODE.CANDIDATE.JOBOPENING)
        return segment.options || []
    }

}

export default ContactService
